import { render, staticRenderFns } from "./user-notifications.vue?vue&type=template&id=07f7223a"
import script from "./user-notifications.vue?vue&type=script&lang=js"
export * from "./user-notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports